<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  *ngIf="!disabled"
  [(ngModel)]="value"
  nzShowSearch
  (ngModelChange)="onModelChange($event)"
  nzAllowClear="true"
  [nzDropdownMatchSelectWidth]="false"
  [required]="isRequired"
  autocomplete="off"
>
  <nz-option
    [nzValue]="useLongCode ? item.longCode : item.code"
    [nzLabel]="item.name"
    *ngFor="let item of options"
    nzCustomContent
  >
    <div class="dropdown-container" *ngIf="showCountryCode">
      <strong>{{ useLongCode ? item.longCode : item.code }}</strong> - <span> {{ item.name }}</span>
    </div>
    <div class="dropdown-container" *ngIf="!showCountryCode">
      <span> {{ item.name }}</span>
    </div>
  </nz-option>
</nz-select>
